import { errorTypes } from "../config/constants";

export const hanldingAudioErr = (pronunciationData: any) => {
  // Assuming you have the provided data stored in a variable named 'pronunciationData'

  // Initialize counters
  let omissionCount = 0;
  let insertionCount = 0;
  let otherErrorCount = 0;
  let mispronuciationsCount = 0;
  let missingBreakCount = 0;

  // Iterate through the words in the data
  for (const wordData of pronunciationData) {
    // Check if the word has PronunciationAssessment
    if (wordData.PronunciationAssessment) {
      // Check the ErrorType
      const errorType = wordData.PronunciationAssessment.ErrorType;
      // Increment counters based on error type
      switch (errorType) {
        case errorTypes.Omission:
          omissionCount++;
          break;
        case errorTypes.Insertion:
          insertionCount++;
          break;
        case errorTypes.Mispronunciation:
          mispronuciationsCount++;
          break;
        case errorTypes.MissingBreak:
          missingBreakCount++;
          break;
        // Add more cases for other error types if needed
        default:
          otherErrorCount++;
          break;
      }
    }
  }
  return {
    omissionCount,
    insertionCount,
    otherErrorCount,
    mispronuciationsCount,
    missingBreakCount,
  };
};

export const monotoneErrHandling = (pronunciationData: any) => {
  let monotoneCount = 0;
  for (const wordData of pronunciationData) {
    if (wordData.PronunciationAssessment.Feedback) {
      const monoErrorType =
        wordData.PronunciationAssessment?.Feedback?.Prosody?.Intonation
          ?.ErrorTypes[0];

      if (monoErrorType === errorTypes.Monotone) {
        monotoneCount++;
      }
    }
  }
  return monotoneCount;
};
export const unexpectedBreakErr = (pronunciationData: any) => {
  let unexpextedBreakCount = 0;
  for (const wordData of pronunciationData) {
    if (wordData.PronunciationAssessment.Feedback) {
      const unexprectBreakErrorType =
        wordData.PronunciationAssessment?.Feedback?.Prosody?.Break
          ?.ErrorTypes[0];

      if (unexprectBreakErrorType === errorTypes.UnexpextedBreak) {
        unexpextedBreakCount++;
      }
    }
  }
  return unexpextedBreakCount;
};
